import { HttpClient } from '@/shared/lib/http-client';

export const fetchTaskAttachmentById = async (attachmentId) => {
  const response = await HttpClient.get(`/tasks/attachments/${attachmentId}/download`);

  return response.data?.data;
};
